import { SiteDetailsTab, tabsConfig } from "../constants"

export function getSiteDetailsTabs(flags, options = {}) {
  return [
    options.buildsEnabled && tabsConfig[SiteDetailsTab.Production],
    options.buildsEnabled && tabsConfig[SiteDetailsTab.PullRequests],
    tabsConfig[SiteDetailsTab.DataLayer],
    tabsConfig[SiteDetailsTab.CmsPreview],
    options?.permissions?.sites?.edit && tabsConfig[SiteDetailsTab.Settings],
  ].filter(Boolean)
}

export function getPathToSiteDetails(siteId, organizationId) {
  return `/dashboard/${organizationId}/sites/${siteId}`
}

export function getSiteDetailsTabBasePath(tab, siteId, organizationId) {
  return `${getPathToSiteDetails(siteId, organizationId)}/${tab}`
}

export function getPathToSiteDetailsTab(tab, siteId, organizationId) {
  const basePath = getSiteDetailsTabBasePath(tab, siteId, organizationId)
  const tabConfig = tabsConfig[tab]

  if (!tabConfig || !tabConfig.hasSections || !tabConfig.initialSection) {
    return basePath
  }
  return `${basePath}/${tabConfig.initialSection}`
}

export function getPathToBuildDetails(buildId, siteId, organizationId) {
  return `${getPathToSiteDetailsTab(
    SiteDetailsTab.Builds,
    siteId,
    organizationId
  )}/${buildId}/details`
}

export function getPathToPullRequestHistory(
  pullRequestId,
  siteId,
  organizationId
) {
  return `${getPathToSiteDetails(
    siteId,
    organizationId
  )}/pull-requests/${pullRequestId}/builds`
}

export function getPathToBuildFunction({
  buildId,
  siteId,
  organizationId,
  functionId,
}) {
  return `${getPathToSiteDetailsTab(
    SiteDetailsTab.Builds,
    siteId,
    organizationId
  )}/${buildId}/functions/${functionId}`
}

export function getPathToBuildsForBranch(branch, siteId, organizationId) {
  const encodedBranchName = encodeURIComponent(branch)
  return `/dashboard/${organizationId}/sites/${siteId}/branches/${encodedBranchName}/builds`
}

export function getPathToBuildsForPR(pullRequestId, siteId, organizationId) {
  return `/dashboard/${organizationId}/sites/${siteId}/pull-requests/${pullRequestId}/builds`
}

export function getPathToSiteSettingsSection(section, siteId, organizationId) {
  return `${getPathToSiteDetailsTab(
    SiteDetailsTab.Settings,
    siteId,
    organizationId
  )}#${section}`
}

export function getPathToDataLayerSection(section, siteId, organizationId) {
  return `${getPathToSiteDetailsTab(
    SiteDetailsTab.DataLayer,
    siteId,
    organizationId
  )}#${section}`
}

export function getPathToSiteSettings({ siteId, organizationId, section }) {
  const basePath = getSiteDetailsTabBasePath(
    SiteDetailsTab.Settings,
    siteId,
    organizationId
  )
  const tabConfig = tabsConfig[SiteDetailsTab.Settings]

  if (!tabConfig || !tabConfig.hasSections || !tabConfig.initialSection) {
    return basePath
  }

  return `${basePath}/${section ? section : tabConfig.initialSection}`
}
